import React from 'react';
import './styles.css';
import Search from './components/Search';

function App() {
  return (
    <div className="App">
      <Search />
    </div>
  );
}

export default App;
